import { render, staticRenderFns } from "./BatchWizard.vue?vue&type=template&id=5cf3065c&"
import script from "./BatchWizard.vue?vue&type=script&lang=js&"
export * from "./BatchWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports